export type ICirclePositions =
  | "4-4-2"
  | "4-3-3"
  | "4-3-2-1"
  | "4-2-3-1"
  | "3-5-2"
  | "4-1-4-1"
  | "3-4-3"
  | "4-5-1"
  | "5-4-1"
  | "4-2-2-2"
  | "3-2-3-2"
  | "3-3-3-1"
  | "3-4-1-2"
  | "3-4-2-1"
  | "3-5-1-1"
  | "4-1-3-2"
  | "4-2-1-3"
  | "4-3-1-2"
  | "4-4-1-1"
  | "5-3-2";

export const circlePositionLogic = {
  "4-4-2": [
    { from: "rw", to: "cf/lwf", circlePosition: "sided" },
    { from: "rw", to: "rcb", circlePosition: "sided" },
    { from: "rcmf", to: "cf/rwf", circlePosition: "sided" },
    { from: "rcmf", to: "rb/rwb", circlePosition: "sided" },
    { from: "rcmf", to: "cf/lwf", circlePosition: "sided" },
    { from: "rcmf", to: "lcb", circlePosition: "sided" },
    { from: "rcb", to: "lcmf", circlePosition: "sided" },
    { from: "lcb", to: "lw", circlePosition: "sided" },
    { from: "cf/lwf", to: "lcmf", circlePosition: "sided" },
    { from: "lb/lwb", to: "lcmf", circlePosition: "sided" },
    { from: "lw", to: "cf/rwf", circlePosition: "sided" },
    { from: "lcmf", to: "cf/rwf", circlePosition: "sided" },
  ],
  "4-3-3": [
    { from: "lb/lwb", to: "dmf", circlePosition: "sided" },
    { from: "rb/rwb", to: "dmf", circlePosition: "sided" },
    { from: "lcb", to: "lcmf3/lamf", circlePosition: "sided" },
    { from: "rcb", to: "rcmf3/ramf", circlePosition: "sided" },
    { from: "dmf", to: "cf", circlePosition: "sided" },
    { from: "lcmf3/lamf", to: "rcmf3/ramf", circlePosition: "sided" },
    { from: "lcmf3/lamf", to: "rw", circlePosition: "sided" },
    { from: "rcmf3/ramf", to: "lw", circlePosition: "sided" },
    { from: "rcmf3/ramf", to: "cf", circlePosition: "sided" },
    { from: "lcmf3/lamf", to: "cf", circlePosition: "sided" },
  ],
  "4-3-2-1": [
    { from: "lb/lwb", to: "dmf", circlePosition: "sided" },
    { from: "rb/rwb", to: "dmf", circlePosition: "sided" },
    { from: "lcb", to: "lcmf3/lamf", circlePosition: "sided" },
    { from: "rcb", to: "rcmf3/ramf", circlePosition: "sided" },
    { from: "lcmf3/lamf", to: "amf/rw", circlePosition: "sided" },
    { from: "rcmf3/ramf", to: "amf/lw", circlePosition: "sided" },
  ],
  "4-2-3-1": [
    { from: "lcb", to: "rdmf/rcmf", circlePosition: "sided" },
    { from: "rcb", to: "ldmf/lcmf", circlePosition: "sided" },
    { from: "lb/lwb", to: "ldmf/lcmf", circlePosition: "sided" },
    { from: "rb/rwb", to: "rdmf/rcmf", circlePosition: "sided" },
    { from: "ramf", to: "lamf", circlePosition: "offsided" },
  ],
  "3-5-2": [
    { from: "lcb3", to: "dmf", circlePosition: "sided" },
    { from: "rcb3", to: "dmf", circlePosition: "sided" },
    { from: "cb", to: "lwb/lw", circlePosition: "sided" },
    { from: "cb", to: "rwb/rw", circlePosition: "sided" },
    { from: "lcb3", to: "lcmf3", circlePosition: "sided" },
    { from: "rcb3", to: "rcmf3", circlePosition: "sided" },
    { from: "cf/rwf", to: "lcmf3", circlePosition: "sided" },
    { from: "cf/lwf", to: "rcmf3", circlePosition: "sided" },
  ],
  "4-1-4-1": [
    { from: "rcb", to: "rw", circlePosition: "sided" },
    { from: "lcb", to: "lw", circlePosition: "sided" },
    { from: "rcb", to: "rcmf", circlePosition: "sided" },
    { from: "lcb", to: "lcmf", circlePosition: "sided" },
    { from: "rcb", to: "lcmf", circlePosition: "sided" },
    { from: "lcb", to: "rcmf", circlePosition: "sided" },
    { from: "lb/lwb", to: "dmf", circlePosition: "sided" },
    { from: "rb/rwb", to: "dmf", circlePosition: "sided" },
    { from: "lw", to: "dmf", circlePosition: "offsided" },
    { from: "rw", to: "dmf", circlePosition: "offsided" },
    { from: "lcb", to: "dmf", circlePosition: "sided" },
    { from: "rcb", to: "dmf", circlePosition: "sided" },
  ],
  "3-4-3": [
    { from: "lcb3", to: "lcmf", circlePosition: "sided" },
    { from: "rcb3", to: "rcmf", circlePosition: "sided" },
    { from: "cb", to: "lwb", circlePosition: "sided" },
    { from: "cb", to: "rwb", circlePosition: "sided" },
  ],
  "4-5-1": [
    { from: "lb/lwb", to: "dmf", circlePosition: "sided" },
    { from: "rb/rwb", to: "dmf", circlePosition: "sided" },
    { from: "lw/lamf", to: "dmf", circlePosition: "offsided" },
    { from: "rw/ramf", to: "dmf", circlePosition: "offsided" },
    { from: "rcb", to: "rw/ramf", circlePosition: "sided" },
    { from: "lcb", to: "lw/lamf", circlePosition: "sided" },
    { from: "rcb", to: "lcmf3", circlePosition: "sided" },
    { from: "lcb", to: "rcmf3", circlePosition: "sided" },
    { from: "rcb", to: "rcmf3", circlePosition: "sided" },
    { from: "lcb", to: "lcmf3", circlePosition: "sided" },
  ],
  "5-4-1": [
    { from: "cb", to: "rb5/rwb", circlePosition: "sided" },
    { from: "cb", to: "lb5/lwb", circlePosition: "othersided" },
    { from: "lcb3", to: "rcmf", circlePosition: "sided" },
    { from: "rcb3", to: "lcmf", circlePosition: "sided" },
    { from: "lcb3", to: "lw/lamf", circlePosition: "offsided" },
    { from: "rcb3", to: "rw/ramf", circlePosition: "offsided" },
    { from: "cb", to: "lcmf", circlePosition: "sided" },
    { from: "cb", to: "rcmf", circlePosition: "sided" },
  ],
  "4-2-2-2": [
    { from: "lcb", to: "rdmf", circlePosition: "sided" },
    { from: "rcb", to: "ldmf", circlePosition: "sided" },
    { from: "cf/lwf", to: "rdmf", circlePosition: "sided" },
    { from: "cf/rwf", to: "ldmf", circlePosition: "sided" },
    { from: "cf/lwf", to: "ramf", circlePosition: "sided" },
    { from: "cf/rwf", to: "lamf", circlePosition: "sided" },
  ],
  "3-2-3-2": [
    { from: "cf/lwf", to: "ldmf", circlePosition: "sided" },
    { from: "cf/rwf", to: "rdmf", circlePosition: "sided" },
    { from: "ramf/rw", to: "amf", circlePosition: "sided" },
    { from: "lamf/lw", to: "amf", circlePosition: "othersided" },
  ],
  "3-3-3-1": [
    { from: "lcb3", to: "dmf", circlePosition: "sided" },
    { from: "rcb3", to: "dmf", circlePosition: "sided" },
    { from: "cb", to: "lcmf3", circlePosition: "sided" },
    { from: "cb", to: "rcmf3", circlePosition: "sided" },
    { from: "cf", to: "lcmf3", circlePosition: "sided" },
    { from: "cf", to: "rcmf3", circlePosition: "sided" },
    { from: "lcmf3", to: "rcmf3", circlePosition: "sided" },
  ],
  "3-4-1-2": [
    { from: "lwb", to: "amf", circlePosition: "sided" },
    { from: "rwb", to: "amf", circlePosition: "sided" },
    { from: "lcmf", to: "cf/lwf", circlePosition: "sided" },
    { from: "rcmf", to: "cf/rwf", circlePosition: "sided" },
  ],
  "3-4-2-1": [
    { from: "lcmf", to: "amf/rw", circlePosition: "othersided" },
    { from: "rcmf", to: "amf/lw", circlePosition: "sided" },
    { from: "amf/rw", to: "amf/lw", circlePosition: "offsided" },
    { from: "cf", to: "rwb", circlePosition: "offsided" },
  ],
  "3-5-1-1": [
    { from: "lcmf3", to: "rcmf3", circlePosition: "sided" },
    { from: "lcmf3", to: "cb", circlePosition: "sided" },
    { from: "rcmf3", to: "cb", circlePosition: "sided" },
    { from: "lcb3", to: "dmf", circlePosition: "sided" },
    { from: "rcb3", to: "dmf", circlePosition: "sided" },
    { from: "lcb3", to: "lcmf3", circlePosition: "sided" },
    { from: "rcb3", to: "rcmf3", circlePosition: "sided" },
    { from: "lw/lamf", to: "dmf", circlePosition: "othersided" },
    { from: "rw/ramf", to: "dmf", circlePosition: "sided" },
  ],
  "4-1-3-2": [
    // Default is already good
  ],
  "4-2-1-3": [
    { from: "lcb", to: "rdmf", circlePosition: "sided" },
    { from: "rcb", to: "ldmf", circlePosition: "sided" },
    { from: "cf", to: "rdmf", circlePosition: "sided" },
    { from: "cf", to: "ldmf", circlePosition: "sided" },
  ],
  "4-3-1-2": [
    { from: "lcb", to: "lcmf3/ldmf", circlePosition: "sided" },
    { from: "rcb", to: "rcmf3/rdmf", circlePosition: "sided" },
    { from: "lcb", to: "rcmf3/rdmf", circlePosition: "sided" },
    { from: "rcb", to: "lcmf3/ldmf", circlePosition: "sided" },
    { from: "lcb", to: "dmf", circlePosition: "sided" },
    { from: "rcb", to: "dmf", circlePosition: "sided" },
  ],
  "4-4-1-1": [
    { from: "lb/lwb", to: "lcmf", circlePosition: "sided" },
    { from: "rb/rwb", to: "rcmf", circlePosition: "sided" },
    { from: "lcb", to: "lw/lamf", circlePosition: "sided" },
    { from: "rcb", to: "rw/ramf", circlePosition: "sided" },
    { from: "lcb", to: "rcmf", circlePosition: "sided" },
    { from: "rcb", to: "lcmf", circlePosition: "sided" },
    { from: "cf", to: "rcmf", circlePosition: "sided" },
    { from: "cf", to: "lcmf", circlePosition: "sided" },
  ],
  "5-3-2": [
    { from: "cb", to: "lb5/lwb", circlePosition: "othersided" },
    { from: "cb", to: "rb5/rwb", circlePosition: "sided" },
    { from: "lcb3", to: "lcmf3", circlePosition: "othersided" },
    { from: "rcb3", to: "rcmf3", circlePosition: "othersided" },
  ],
};
